import { CachePolicies, useFetch } from 'use-http';
import { routes } from '@/webapi/routes';
import { Audience } from '@/features/dashboard/audiences/models';

export function useAudiencesApi(initialLoading = false) {
  const { put, post, loading } = useFetch(``, (globalOptions) => ({
    ...globalOptions,
    ...{
      credentials: `include`,
      cachePolicy: CachePolicies.NO_CACHE,
      loading: initialLoading,
    },
  }));

  const { put: put2, loading: loadingPrimaryAudiencesSet } = useFetch(
    ``,
    (globalOptions) => ({
      ...globalOptions,
      ...{
        credentials: `include`,
        cachePolicy: CachePolicies.NO_CACHE,
        loading: false,
      },
    }),
  );

  const createAudience = (audience: Audience) =>
    post(routes.audiences, audience);

  const deleteAudience = (audience: Audience) =>
    post(routes.deleteAudiences, audience);

  const updateAudience = (audience: Audience) =>
    put(routes.audiences, audience);

  const toggleAudience = (audience: Audience) =>
    put2(routes.togglePrimaryAudience, audience);

  const listAudiences = (startAt = null, endAt = null, onlyPrimary = false) =>
    post(routes.audiencesList, {
      startAt,
      endAt,
      onlyPrimary,
    }) as Promise<{
      audiences: Array<Audience>;
    }>;

  return {
    loadingPrimaryAudiencesSet,
    toggleAudience,
    createAudience,
    listAudiences,
    updateAudience,
    deleteAudience,
    loading,
  };
}
